var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.5;}\n\t.st1{fill:#D68828;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    className: "st0",
    d: "M256,509C116.3,509,3,395.7,3,256S116.3,3,256,3s253,113.3,253,253l0,0l0,0 C508.8,395.7,395.7,508.8,256,509z M256,27.3C129.7,27.3,27.3,129.7,27.3,256S129.7,484.7,256,484.7S484.7,382.3,484.7,256l0,0 C484.5,129.7,382.3,27.4,256,27.2V27.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    className: "st1",
    d: "M289.3,200.8c-16.5,56.1-26.4,113.9-29.6,172.3c-0.4,2.5,1.4,4.8,3.9,5.2c0.1,0,0.1,0,0.2,0 c1.5,0.2,2.9-0.3,3.9-1.4c44.2-38.5,82.3-83.6,112.8-133.7c11.8-25.2,0.9-55.1-24.3-66.9c-25.2-11.8-55.1-0.9-66.9,24.3l0,0 V200.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    className: "st1",
    d: "M222.8,200.8c16.5,56.1,26.4,113.9,29.6,172.3c0.5,2.5-1.1,5-3.6,5.5c-0.3,0.1-0.6,0.1-0.8,0.1 c-1.5,0.2-2.9-0.3-3.9-1.4c-44.1-38.7-82.1-83.9-112.4-134.1c-11.8-25.2-0.9-55.1,24.3-66.9s55.1-0.9,66.9,24.3V200.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.62013bd4114f6ca696bbfca49f7e8c07.svg";
export { ForwardRef as ReactComponent };